import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import {
  NgTemplateOutlet,
  NgClass,
  AsyncPipe,
  CurrencyPipe,
  CommonModule,
} from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule, MatRippleModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatChipsModule } from "@angular/material/chips";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTableModule } from "@angular/material/table";

@Component({
  selector: "app-role-detail",
  standalone: true,
  imports: [
    MatProgressBarModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatSortModule,
    NgTemplateOutlet,
    MatPaginatorModule,
    NgClass,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatRippleModule,
    MatChipsModule,
    AsyncPipe,
    CurrencyPipe,
    CommonModule,
    MatExpansionModule,
    MatDialogModule,
    MatTableModule,
  ],
  templateUrl: "./role-detail.component.html",
  styleUrl: "./role-detail.component.scss",
})
export class RoleDetailComponent implements OnInit {
  functionalPermissionList: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<RoleDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public role: any
  ) {}

  ngOnInit(): void {
    // We call this in ngOnInit to ensure data passed via MAT_DIALOG_DATA is ready
    this.prepareFunctionalPermissions();
  }

  prepareFunctionalPermissions() {
    if (this.role?.functionalPermission?.length > 0) {
      // CRITICAL: We create a deep copy using JSON.parse/stringify.
      // This ensures that the component gets its own fresh reference of the data.
      const rawData = JSON.parse(JSON.stringify(this.role.functionalPermission));

      this.functionalPermissionList = rawData.map((module: any) => ({
        ...module,
        isExpanded: false,
        subModules: module.subModules?.map((sub: any) => ({
          ...sub,
          permissions: {
            // Explicitly casting to boolean ensures the checkbox state matches exactly
            read: !!sub?.permissions?.read,
            write: !!sub?.permissions?.write,
            delete: !!sub?.permissions?.delete,
          },
        })),
      }));
    } else {
      this.functionalPermissionList = [];
    }
  }

  /**
   * Utility to check if the module checkbox should be "checked"
   * Iterates through subModules to find any true permission.
   */
  hasValidPermissions(module: any): boolean {
    if (!module?.subModules) return false;
    return module.subModules.some((sub: any) =>
      sub.permissions.read || sub.permissions.write || sub.permissions.delete
    );
  }

  editRole() {
    this.dialogRef.close({ action: "edit", role: this.role });
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  getEnabledAction(sub: any): "read" | "write" | "delete" {
    const all: Array<"read" | "write" | "delete"> = ["read", "write", "delete"];
    const disabled = sub?.disabledPermissions ?? [];
    return all.find((a) => !disabled.includes(a)) ?? "read";
  }

  getDisplayPermissionName(name: string): string {
    if (!name) return "";
    const normalized = name.trim().toLowerCase();
    if (normalized === "view my tasks" || normalized === "view my task") {
      return "View";
    }
    return name;
  }
}